import countries from 'viralstyle-ui/src/shippableCountries';

export class CustomerModel {
  constructor(customer, isLocal) {
    if (customer && !isLocal) {
      this._initFromCustomer(customer);
    } else if (customer && isLocal) {
      this._initFromLocalCustomer(customer);
    } else {
      this._initDefaults();
    }
  }

  _initDefaults() {
    this.email = '';
    this.password = '';
    this.name = '';
    this.street_1 = '';
    this.street_2 = '';
    this.city = '';
    this.province = null;
    this.postal_code = '';
    this.country = null;
    this.phone = '';
    this.remember = false;
    this.dashboard_url = '';
    this.public_name = '';
    this.tier_discount = 0;
  }

  _initFromCustomerShared(customer) {
    this.email = customer.email;
    this.password = '';
    this.name = customer.name;
    this.phone = customer.phone;
    this.remember = false;
    this.public_name = customer.public_name;
    this._links = customer._links;
  }

  _initFromCustomer(customer) {
    this._initFromCustomerShared(customer);

    this.street_1 = customer.shipping_address.street_1;
    this.street_2 = customer.shipping_address.street_2;
    this.city = customer.shipping_address.city;
    this.province = customer.shipping_address.province;
    this.postal_code = customer.shipping_address.zip;
    this.country = customer.shipping_address.country;
    this.role = customer.role;
    this.timezone = customer.timezone;
    this.dashboard_url = customer.dashboard_url;
    this.is_impersonation = customer.is_impersonation;
    this.tier_discount = customer.tier_discount;

    if (!countries[customer.shipping_address.country]) {
      this.country = null;
      this.province = null;
    }
  }

  _initFromLocalCustomer(customer) {
    this._initFromCustomerShared(customer);
    this.street_1 = customer.street_1;
    this.street_2 = customer.street_2;
    this.city = customer.city;
    this.province = customer.province;
    this.postal_code = customer.postal_code;
    this.country = customer.country;

    if (!countries[customer.country]) {
      this.country = null;
      this.province = null;
    }
  }
};

export class CardModel {
  constructor() {
    this.number = '';
    this.expYear = null;
    this.expMonth = null;
    this.securityCode = '';
    this.token = '';
    this.cc_bin = '';
    this.remember = false;
  }
};